
export const PACKAGE_SCAN_TYPE = {
    SCAN_STORE: 'escaneo-tienda',
    SCAN_WAREHOUSE: 'recepcion-bodega',
    SCAN_IN_TRANSIT: 'ruta-conductor',
    SCAN_EXCHANGE_RETURN: 'cambio-devolucion'
}

export const PACKAGE_SCAN_MODE = {
    MANUAL: 'manual',
    QR: 'qr'
}


